<template>
  <b-container class="container-rda">
    <b-row>
      <b-col>
        <Breadcrumb :breadcrumb="breadcrumb" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h2 class="purple bold">Alunos</h2>
      </b-col>
      <b-col class="text-right">
        <b-button class="btn large blue" :to="{ name: 'alunos' }"
          >Cancelar</b-button
        >
      </b-col>
    </b-row>
    <b-row class="mt-50">
      <b-col>
        <SelectCalendar
          label="Ano"
          placeholder="Selecione"
          v-model="calendar"
          :callback="callbackCalendars"
          :yearsBack="3"
        >
        </SelectCalendar>
      </b-col>
      <b-col>
        <SelectCycles v-model="cycle" :callback="callbackCycles"></SelectCycles>
      </b-col>
      <b-col>
        <SelectClassrooms
          v-model="classroom"
          :callback="callbackClassrooms"
          :cycle="cycle"
        ></SelectClassrooms>
      </b-col>
      <b-col>
        <form @submit.prevent="search">
          <b-form-group label="Buscar alunos">
            <b-input-group-prepend>
              <b-form-input
                v-model="searchTerm"
                type="search"
                placeholder="Digite aqui"
              />
            </b-input-group-prepend>
            <b-input-group-text
              class="clear-fields"
              v-if="
                searchTerm != '' ||
                cycle != null ||
                classroom != null ||
                calendar != null
              "
              v-b-tooltip.hover
              title="Limpar Pesquisa"
            >
              <b-icon icon="x" @click="clearFields" />
            </b-input-group-text>
          </b-form-group>
        </form>
      </b-col>
      <b-col md="auto" class="d-flex align-items-end pb-3">
        <b-button
          class="btn blue"
          @click="clearFields"
          v-if="
            searchTerm != '' ||
            cycle != null ||
            classroom != null ||
            calendar != null
          "
        >
          Limpar filtros
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-container fluid>
          <b-row
            class="header-list-teacher"
            v-if="wasRequestMade && students.length"
          >
            <b-col md="1"></b-col>
            <b-col md="2" style="padding-left: 0">
              <p class="bold">Matrícula</p>
            </b-col>
            <b-col md="6">
              <p class="bold">Nome</p>
            </b-col>
            <b-col>
              <p class="bold">Turma</p>
            </b-col>
            <b-col>
              <p class="bold">Ciclo</p>
            </b-col>
          </b-row>
        </b-container>
        <b-container fluid>
          <b-row
            align-v="center"
            class="list-teacher"
            v-for="student in students"
            :key="student.id"
          >
            <b-col md="1" class="align-center">
              <b-form-checkbox
                v-model="userIds"
                :value="student.id"
              ></b-form-checkbox>
            </b-col>
            <b-col
              md="2"
              class="name"
              style="padding-left: 0"
              @click="toggleStudent(student.id)"
            >
              <p class>{{ student.id }}</p>
            </b-col>
            <b-col md="6" class="name" @click="toggleStudent(student.id)">
              <p class>{{ student.name }}</p>
            </b-col>
            <b-col @click="toggleStudent(student.id)">
              <p
                class="tags"
                style="max-width: 100px"
                v-if="student.classroom_designation"
              >
                {{ student.classroom_designation }}
              </p>
              <p class="tags" v-else>Sem Ciclo</p>
            </b-col>
            <b-col @click="toggleStudent(student.id)">
              <p
                class="tags"
                style="max-width: 100px"
                v-if="student.cycle_name"
              >
                {{ student.cycle_name }}
              </p>
              <p class="tags" v-else>Sem Ciclo</p>
            </b-col>
          </b-row>
        </b-container>
        <b-container fluid>
          <b-row
            align-v="center"
            class="list-teacher no-click"
            v-if="wasRequestMade && !students.length && hasValidFilters"
          >
            <b-col>Nenhum resultado encontrado</b-col>
          </b-row>
          <b-row
            align-v="center"
            class="list-teacher info-message"
            v-if="wasRequestMade && !hasValidFilters"
          >
            <b-col>
              <p class="text-center">
                <strong>Selecione pelo menos um filtro:</strong> Turma, Ciclo,
                Ano ou digite um termo de busca.
              </p>
            </b-col>
          </b-row>
          <b-row
            align-v="center"
            class="list-teacher no-click"
            v-if="!wasRequestMade"
          >
            <b-col>Carregando</b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
    <b-row class="mt-5 align-center">
      <b-col>
        <b-button class="btn large outline checkbox">
          <b-form-checkbox @change="selectAll" v-model="allSelected">{{
            allSelected ? "Deselecionar todos" : "Selecionar todos"
          }}</b-form-checkbox>
        </b-button>
      </b-col>
      <b-col class="text-right">
        <b-button
          class="btn large blue"
          @click="createCards"
          :class="{
            disabled: userIds.length <= 0 || !hasValidFilters,
          }"
          :disabled="userIds.length <= 0 || !hasValidFilters || loading"
          >{{ loadText }}</b-button
        >
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions } from "vuex";
import DataService from "@/services/students.service";

import SelectCalendar from "@/components/inputs/SelectCalendar.vue";
import SelectClassrooms from "@/components/inputs/SelectClassrooms.vue";
import SelectCycles from "@/components/inputs/SelectCycles.vue";
import HttpRda from "../../../http-rda";

export default {
  name: "emitir-carteirinha",
  components: {
    SelectCalendar,
    SelectClassrooms,
    SelectCycles,
  },
  data() {
    return {
      userIds: [],
      loading: false,
      allSelected: false,
      wasRequestMade: false,
      studentToEdit: {},

      cycle: null,
      classroom: null,
      calendar: null,
      searchTerm: "",

      students: [],

      loadText: "Imprimir PDF",

      breadcrumb: [
        {
          text: "Comunidade",
          href: "/comunidade",
        },
        {
          text: "Alunos",
          href: "/alunos",
        },
        {
          text: "Emitir carteirinha",
          href: "/emitir-carteirinha",
          active: true,
        },
      ],
    };
  },
  computed: {
    hasValidFilters() {
      return (
        this.cycle !== null ||
        this.classroom !== null ||
        this.calendar !== null ||
        (this.searchTerm && this.searchTerm.trim().length > 0)
      );
    },
  },
  methods: {
    ...mapActions({
      getStudents: "community/listStudents",
      getStudent: "community/getStudent",
      deleteStudent: "community/deleteStudent",
      updateStatusStudents: "community/updateStatusStudents",
    }),

    callbackCycles({ id }) {
      this.cycle = id !== -1 ? id : null;
      this.userIds = [];
      this.allSelected = false;
      this.listStudents();
    },

    callbackClassrooms({ id }) {
      this.classroom = id !== -1 ? id : null;
      this.userIds = [];
      this.allSelected = false;
      this.listStudents();
    },

    callbackCalendars({ id }) {
      this.calendar = id !== -1 ? id : null;
      this.userIds = [];
      this.allSelected = false;
      this.listStudents();
    },

    async listStudents() {
      if (!this.hasValidFilters) {
        this.students = [];
        this.wasRequestMade = true;
        return;
      }

      const params = {
        search: this.searchTerm,
        cycle: this.cycle,
        classroom: this.classroom,
        calendar: this.calendar,
      };

      await HttpRda.get("/students/get_students_for_cards", { params })
        .then((res) => {
          this.students = res.data.students || [];
          this.wasRequestMade = true;
        })
        .catch(() => {
          this.students = [];
          this.wasRequestMade = true;
        });
    },

    search() {
      this.userIds = [];
      this.allSelected = false;
      this.listStudents();
    },

    clearFields() {
      this.searchTerm = "";
      this.cycle = null;
      this.classroom = null;
      this.calendar = null;
      this.students = [];
      this.userIds = [];
      this.allSelected = false;
      this.wasRequestMade = true;
    },

    selectAll(student) {
      this.userIds = [];

      if (this.allSelected) {
        for (student in this.students) {
          this.userIds.push(this.students[student].id);
        }
      }
    },

    toggleStudent(studentId) {
      const index = this.userIds.indexOf(studentId);
      if (index > -1) {
        this.userIds.splice(index, 1);
      } else {
        this.userIds.push(studentId);
      }
      this.allSelected = false;
    },

    createCards() {
      this.loading = true;
      var data = {
        students: this.userIds,
      };
      this.loadText = "Por favor, aguarde...";
      DataService.getStudentsCards(data)
        .then((response) => {
          this.loading = false;
          this.userIds = [];
          this.allSelected = false;
          this.loadText = "Imprimir PDF";

          var date = new Date();

          var newBlob = new Blob([response.data], { type: "application/pdf" });

          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
            return;
          }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          data = window.URL.createObjectURL(newBlob);
          var link = document.createElement("a");
          link.href = data;
          link.download = `Carteirinha_${date.getDate()}-${date.getMonth()}-${date.getFullYear()}_${date.getTime()}`;
          link.click();

          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
          }, 100);

          const Toast = this.$swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: `Carteirinha(s) emitida(s) com sucesso!`,
          });

          return response;
        })
        .catch((error) => {
          this.loading = false;
          this.loadText = "Imprimir PDF";
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel atualizar o perfil!",
            footer: "Por favor, verifique se os campos estão preenchidos.",
          });

          return error;
        });
    },
  },

  created() {
    this.wasRequestMade = true;
  },
};
</script>

<style lang="scss">
@import "@/assets/css/variables.scss";

.disabled {
  filter: grayscale(1);
  opacity: 0.7;
  pointer-events: none;
}

.list-teacher {
  background-color: $white;
  border: 1px solid $grey5;
  border-radius: 10px;
  margin-bottom: 15px;
  min-height: 80px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: transparent;
    background-image: linear-gradient($white, $white),
      radial-gradient(circle at top left, $orange, $purple);
    background-origin: border-box;
    background-clip: content-box, border-box;
  }

  p {
    margin: 0;
  }

  &.no-click {
    cursor: default;

    &:hover {
      border-color: $grey5;
      background-image: none;
    }
  }

  &.info-message {
    background-color: #f8f9fa;
    border-color: $blue;
    cursor: default;

    &:hover {
      border-color: $blue;
      background-image: none;
      background-color: #f8f9fa;
    }

    p {
      color: $grey4;
      padding: 10px 0;
    }
  }

  .disciplines {
    .name {
      display: inline-block;
      line-height: 22px;

      .comma {
        margin-right: 4px;
      }

      &:last-child {
        .comma {
          display: none;
        }
      }
    }
  }

  .cycles {
    display: flex;
    flex-wrap: wrap;
  }

  .tags {
    background-color: $blue;
    border-radius: 5px;
    color: $white;
    font-weight: $bold;
    line-height: 28px;
    margin: 3px 12px 3px 0;
    max-width: 58px;
    padding: 0 3px;
    text-align: center;
    vertical-align: middle;
  }
}
</style>
